module.exports = __webpack_public_path__ + "media/dne-token.62c7e8a5.mp4";